import React from "react";

const TransparentButton = ({
  buttonText,
  buttonClass = "px-3.5 py-2.5 border border-custom-blue text-custom-blue text-sm font-medium rounded-lg hover:bg-custom-blue hover:text-white focus:outline-none focus:ring-2 focus:ring-custom-blue focus:ring-opacity-50 transition duration-300 ease-in-out",
  onClick,
  width,
  disabled = false,
}) => {
  return (
    <button
      onClick={!disabled ? onClick : undefined}
      className={`${buttonClass} ${width} ${
        disabled
          ? "cursor-not-allowed opacity-50 hover:bg-transparent hover:text-custom-blue border-gray-400 text-gray-400"
          : ""
      }`}
      disabled={disabled}
    >
      {buttonText}
    </button>
  );
};

export default TransparentButton;
